import { h } from "preact";
import { IdPrefixContext } from "../../helpers/idPrefixContext";
import ProductOptionPill from "../product-options/product-option-pill";
import ProductOptionSwatchHeader from "../product-options/product-option-swatch-header";

export const GIFT_CARD_TYPES = {
  physical: "physical",
  digital: "digital",
};

// Borrows the pill markup — `product-options` wrapper included — so the two
// products read as one product's first option alongside the real ones below.
export default function GiftCardTypeToggle({ idPrefix, value, onChange }) {
  const optionName = window.localeStrings.product.gift_card_type_label;

  const types = [
    {
      type: GIFT_CARD_TYPES.digital,
      name: window.localeStrings.product.gift_card_type_digital,
    },
    {
      type: GIFT_CARD_TYPES.physical,
      name: window.localeStrings.product.gift_card_type_physical,
    },
  ];

  return (
    <div className="product-options">
      <div className="product-options__option product-options__option--pills">
        <ProductOptionSwatchHeader optionName={optionName} />
        <IdPrefixContext.Provider value={idPrefix}>
          <fieldset
            className="product-options__pill-list"
            style={{ "--pill-columns": types.length }}
          >
            <legend className="visually-hidden">{optionName}</legend>
            {types.map(({ type, name }) => (
              <ProductOptionPill
                key={type}
                optionValue={{ name }}
                optionName={optionName}
                updateOptionValue={() => onChange(type)}
                selected={type === value}
              />
            ))}
          </fieldset>
        </IdPrefixContext.Provider>
      </div>
    </div>
  );
}
